import { PublicHeader } from '../components/PublicHeader';
import { Orbs } from '../components/landing/primitives';
import { Footer } from '../components/landing/sections';
import PricingPage from './PricingPage';

export default function PublicPricingPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="public-pricing-page">
      <PublicHeader />
      <main className="relative overflow-hidden">
        <Orbs variant="section" />
        <div className="relative max-w-[1600px] mx-auto px-4 md:px-8 py-10 md:py-14">
          <PricingPage />
        </div>
      </main>
      <Footer />
    </div>
  );
}
